import {
    IAccountStatistic,
} from 'entities/account-statistics/types/account-statistic';

import {
    PAYMENT_STATUS,
} from 'entities/payments/constants';

interface IParams {
    accountStatistic: IAccountStatistic | null;
    isPending: boolean;
    isFailed: boolean;
    currentSeconds: number;
}

export function getRedirectUrl({
    accountStatistic,
    isPending,
    isFailed,
    currentSeconds,
}: IParams): string | null {
    if (!accountStatistic) {
        return null;
    }

    const {
        successUrl,
        failUrl,
    } = accountStatistic.paymentPageInfo;

    if (!accountStatistic.payment) {
        if (isFailed) {
            return failUrl;
        }
        if (!isPending && currentSeconds <= 0) {
            return failUrl;
        }

        return null;
    }

    switch (accountStatistic.payment.status) {
        case PAYMENT_STATUS.SUCCESS: {
            return successUrl;
        }
        case PAYMENT_STATUS.FAILED: {
            return failUrl;
        }
        default: {
            return null;
        }
    }
}
